import { supabase } from './supabase/client';

export async function saveSubscriber(email: string) {
  try {
    // First check if email already exists to handle duplicates gracefully
    const { data: existing, error: selectError } = await supabase
      .from('subscribers')
      .select('email')
      .eq('email', email)
      .maybeSingle(); // Use maybeSingle instead of single to handle no results

    if (selectError) {
      console.error('Error checking existing subscriber:', selectError);
      throw new Error('Failed to check email subscription');
    }

    if (existing) {
      return { email: existing.email }; // Return normalized response
    }

    // Insert new subscriber
    const { data, error: insertError } = await supabase
      .from('subscribers')
      .insert([{ email }])
      .select('email')
      .single();

    if (insertError) {
      console.error('Error inserting subscriber:', insertError);
      throw new Error('Failed to save email subscription');
    }

    return data;
  } catch (error) {
    console.error('Error in saveSubscriber:', error);
    throw error;
  }
}